import { render, staticRenderFns } from "./product-item-specification.vue?vue&type=template&id=5adef943&scoped=true&"
import script from "./product-item-specification.vue?vue&type=script&lang=js&"
export * from "./product-item-specification.vue?vue&type=script&lang=js&"
import style0 from "./product-item-specification.vue?vue&type=style&index=0&id=5adef943&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adef943",
  null
  
)

export default component.exports